"use strict";

;
;

(function ($) {
  /**
   * 购物车对象
   */
  function Car(eles) {
    this.eles = eles;
    this.ordersEle = $(eles.ordersEle);
  }

  $.extend(Car.prototype, {
    init: function init() {
      this.initCars();
    },

    /**
     * 更新购物车数据
     * @param {*} carData 
     */
    update: function update(carData) {
      this.carsList[carData.id] = carData;
      localStorage.setItem("cars", JSON.stringify(this.carsList));
      this.renderData();
    },
    "delete": function _delete(productId) {
      delete this.carsList[productId];
      localStorage.setItem("cars", JSON.stringify(this.carsList));
      this.renderData();
    },

    /**
     * 初始化购物车数据
     */
    initCars: function initCars() {
      this.carsList = JSON.parse(localStorage.getItem("cars")) || {};
      this.renderData();
      this.bindEvent();
    },
    bindEvent: function bindEvent() {
      var that = this; // 选择数量 加法的

      this.ordersEle.on("click", that.eles.numAdd, function () {
        // 获取输入框的数字
        var num = Number($(that.eles.numInput).val()); // 获取这个商品的id好

        var productId = $(this).parents("tr").find("input[name=productId]").val();
        num++;
        $(that.eles.numInput).val(num); // 获取这个购物车localStorage中对应的商品数据

        var carData = that.carsList[productId];
        carData.num = num; // 更新数据

        that.update(carData);
      }); // 选择数量减法的

      this.ordersEle.on("click", that.eles.numReduce, function () {
        // 获取输入框中的数据
        var num = Number($(that.eles.numInput).val()); // 获取这个商品的id值

        var productId = $(this).parents("tr").find("input[name=productId]").val();
        num--;

        if (num === 0) {
          return false;
        }

        $(that.eles.numInput).val(num); // 从新计算数据

        var carData = that.carsList[productId];
        carData.num = num;
        that.update(carData);
      });
      /**
       * 删除按钮的事件
       */

      this.ordersEle.on("click", that.eles.deleteBtn, function () {
        var productId = $(this).parents("tr").find("input[name=productId]").val();
        that["delete"](productId);
      });
    },
    bindImageHover: function bindImageHover() {
      $(".product-pic").hover(function () {
        $(".product-pic-preview-tooltips").addClass("product-tooltips-show");
      }, function () {
        $(".product-pic-preview-tooltips").removeClass("product-tooltips-show");
      });
    },
    renderCarData: function renderCarData() {
      var carData = this.carsList;
      var html = "";

      for (var attr in carData) {
        html += "<tr class=\"goods_item\">\n                <input type=\"hidden\" name=\"productId\" value=\"".concat(attr, "\">\n                <td class=\"product-item\">\n                    <div class=\"m-product product-small\">\n                        <div class=\"product-pic product-pic-trigger\">\n                            <a href=\"javascript:void(0)\">\n                                <img width=\"58\" height=\"74\"\n                                    src=\"").concat(carData[attr].images[0], "\"\n                                    alt=\"\" />\n                            </a>\n                            <div class=\"product-pic-preview-tooltips ui-tooltips\">\n                                <div class=\"ui-tooltips-content\">\n                                    <img class=\"\"\n                                        src=\"").concat(carData[attr].images[0], "\"\n                                        alt=\"").concat(carData[attr].longTitle, "\" width=\"184\"\n                                        height=\"234\">\n                                </div>\n                            </div>\n                        </div>\n                        <h3 class=\"product-title\">\n                            <span class=\"u-saletype u-saletype-0\">\u81EA\u8425</span>\n                            <a href=\"javascript:void(0)\">").concat(carData[attr].longTitle, "</a>\n                        </h3>\n                        <p class=\"product-size\">\u5C3A\u7801\uFF1A").concat(carData[attr].size, "</p>\n                        <div class=\"product-price-tip\">\n                            <span class=\"product-tip\">\u6298\u540E\u4EF7</span>\n                        </div>\n                    </div>\n                </td>\n                <td class=\"price-item\">\n                    <div class=\"m-price\">\n                        <span class=\"goods-cxoprice-tag u-hidden\"></span>\n                        <span class=\"u-yen\">\xA5</span><strong class=\"u-price\">").concat(carData[attr].promotion_price, "</strong>\n                    </div>\n                    <del class=\"m-price market-price\">\n                        <span class=\"u-yen\">\xA5</span><span class=\"u-price\">").concat(carData[attr].max_market_price, "</span>\n                    </del>\n                </td>\n                <td class=\"quantity-item\">\n                    <div class=\"m-amount confirm_box cart_amount_confirm_box clearfix\">\n                        <a class=\"iconfont icon-jianhao icon-reduce num-reduce\"\n                            href=\"javascript:void(0)\">\n                        </a>\n                        <div title=\"\u8BF7\u9009\u62E9\u8D2D\u4E70\u6570\u91CF\" class=\"amount-num\">\n                            <input name=\"num\" type=\"text\" disabled value=\"").concat(carData[attr].num, "\"\n                                class=\"cart_num num-input\" />\n                        </div>\n                        <a class=\"iconfont icon-jiahao icon-add num-add\"\n                            href=\"javascript:void(0)\">\n                        </a>\n                    </div>\n                </td>\n                <td class=\"subtotal-item\">\n                    <span class=\"m-price  subtotal-price\">\n                        <span class=\"u-yen\">\xA5</span>\n                        <strong class=\"u-price\">\n                            ").concat(carData[attr].promotion_price * carData[attr].num, "\n                        </strong>\n                    </span>\n                </td>\n                <td class=\"actions-item\">\n                    <a href=\"javascript:void(0)\" class=\"dellCarBtn\">\u5220\u9664</a>\n                </td>\n            </tr>");
      }

      this.ordersEle.html(html);
      this.notAllowedCheck();
    },
    renderTotalPrice: function renderTotalPrice() {
      var html = "";
      var totalNum = 0;
      var totalPrice = 0;

      for (var attr in this.carsList) {
        totalNum += this.carsList[attr].num;
        totalPrice += this.carsList[attr].num * this.carsList[attr].promotion_price;
      }

      html += "<p class=\"price-panel\">\u5171<span class=\"quantity\">".concat(totalNum, "</span>\u4EF6\u5546\u54C1&nbsp;&nbsp;\u5546\u54C1\u91D1\u989D<span\n            class=\"m-price\"><span>\xA5</span>").concat(totalPrice, "</span></p>\n            <p class=\"price-panel\">\u603B\u91D1\u989D(\u672A\u542B\u8FD0\u8D39)<span class=\"m-price totalPrice\"><span>\xA5</span>").concat(totalPrice, "</span>\n            </p>");
      $(".orders-total-bd").html(html);
    },
    renderData: function renderData() {
      this.renderCarData();
      this.renderTotalPrice();
      this.bindImageHover();
    },

    /**
     * 加减按钮的不允许状态检查
     */
    notAllowedCheck: function notAllowedCheck() {
      var num = Number($(this.eles.numInput).val());

      if (num <= 1) {
        $(this.eles.numReduce).css({
          cursor: "not-allowed"
        });
      } else {
        $(this.eles.numReduce).css({
          cursor: "pointer"
        });
      }
    }
  });
  /**
   * 检查登录
   */

  function checkLogin() {
    var userInfo = $.cookie("userLoginInfo"); // 等于undefined直接结束

    if (userInfo === undefined) {
      return false;
    } // 不然我们需要将用户信息放在页面之中 表示已登录


    var user = JSON.parse(userInfo);
    $(".username").html(user.username);
  }
  /**
   * 退出
   */


  function logout() {
    // 给退出按钮绑定事件
    $(".linkLogout").on("click", function (e) {
      e.preventDefault ? e.preventDefault() : e.returnValue = false;
      $.removeCookie("userLoginInfo");
      location.reload();
    });
  }
  /**
   * 页面初始化函数
   */


  function init() {
    checkLogin();
    logout();
    new Car({
      ordersEle: ".orders-table",
      numReduce: ".num-reduce",
      numAdd: ".num-add",
      numInput: ".num-input",
      deleteBtn: ".dellCarBtn"
    }).init();
  }

  var callbacks = $.Callbacks();
  callbacks.add(init);
  callbacks.fire();
})(jQuery);